document.addEventListener("DOMContentLoaded", (event) => {
    var cfElements = document.getElementsByName('cf-captcha-response');
    if (cfElements == null || cfElements.length == 0) return;

    var targetElement = cfElements[0];
    targetElement.addEventListener("selectionchange", (event) => {
        let tokenElement = document.getElementById('captchafox-token');
        tokenElement.value = event.target.value;

    });
});
